import { render, staticRenderFns } from "./_expensesType.vue?vue&type=template&id=1994894c&scoped=true&"
import script from "./_expensesType.vue?vue&type=script&lang=js&"
export * from "./_expensesType.vue?vue&type=script&lang=js&"
import style0 from "./_expensesType.vue?vue&type=style&index=0&id=1994894c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1994894c",
  null
  
)

export default component.exports